export default __webpack_public_path__ + "static/media/AthleticsLogo.cd4f3982.png";